import { render, staticRenderFns } from "./Ovo.vue?vue&type=template&id=212098bd"
import script from "./Ovo.vue?vue&type=script&lang=js"
export * from "./Ovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../alternate-energy-market-switching/node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports